import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { paths } from 'src/routes/paths';

export const comprarInsumoProveedor = createAsyncThunk(
  'insumoProveedorForm/comprarInsumoProveedor',
  async (
    { data, navigate }: { data: any; navigate: any },
    { rejectWithValue }
  ) => {
    try {
      navigate(paths.dashboard.compras.compras, {
        state: { data, openModalFromInsumo: true },
      });
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(error.response?.data || 'Error al navegar');
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const actualizarInsumoProveedorPrecio = createAsyncThunk(
  'insumoProveedorForm/actualizarInsumoProveedorPrecio',
  async (
    { data, formRef }: { data: any; formRef: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(
        endpoints.actions.actualizarInsumoProveedorPrecio,
        data
      );
      console.log('data', data);
      formRef.current.instance.updateData({
        ultimaActualizacion: response.data.ultimaActualizacion,
        ultimaCompra: response.data.ultimaCompra,
        ultimoPrecioUnitario: response.data.ultimoPrecioUnitario,
        ultimoPrecioPorBulto: response.data.ultimoPrecioPorBulto,
        actualizadoAMano: false,
      });
      handleOKRequest(response, 'Precio del insumo actualizado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al actualizar el precio del insumo.'
      );
    }
  }
);
